import { render, staticRenderFns } from "./CategoryPriority.vue?vue&type=template&id=4bfbd7d5&"
import script from "./CategoryPriority.vue?vue&type=script&lang=js&"
export * from "./CategoryPriority.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPriority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports